var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab', _vm._b({
    staticClass: "min-w-auto",
    attrs: {
      "exact-path": "",
      "active-class": "v-tab--active"
    }
  }, 'v-tab', _vm.$attrs, false), [_c('v-btn', {
    staticClass: "v-size--xx-large min-w-md-230px",
    attrs: {
      "color": "grey lighten-5"
    }
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._t("default")], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }